exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".kye-copy-area {\n  position: relative; }\n  .kye-copy-area:before {\n    background: #409eff;\n    bottom: 0;\n    content: \"\";\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    opacity: .2; }\n", "", {"version":3,"sources":["/data/node_workspace_2_15/workspace/uat-deploy-erp-frontproject/src/public/plugins/copy-cells/set-cell-style/style.scss"],"names":[],"mappings":"AAAA;EACE,mBAAmB,EAAE;EACrB;IACE,oBAAoB;IACpB,UAAU;IACV,YAAY;IACZ,QAAQ;IACR,mBAAmB;IACnB,SAAS;IACT,OAAO;IACP,YAAY,EAAE","file":"style.scss","sourcesContent":[".kye-copy-area {\n  position: relative; }\n  .kye-copy-area:before {\n    background: #409eff;\n    bottom: 0;\n    content: \"\";\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    opacity: .2; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/cache-loader/dist/cjs.js!./node_modules/css-loader??ref--10-2!./node_modules/postcss-loader/lib??ref--10-3!./node_modules/fast-sass-loader/lib??ref--10-4!./src/public/plugins/copy-cells/set-cell-style/style.scss
// module id = lZSm
// module chunks = 6